'use client'
import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC } from 'react'

import { PhnxJotformiframe } from './Jotformiframe'
import { JotformiframeProps } from './Jotformiframe'

interface JotformiframeBlokProps {
  blok: {
    title: JotformiframeProps['title']
    formId: string
    height: number
  } & SbBlokData
}

const Jotformiframe: FC<JotformiframeBlokProps> = ({ blok }) => {
  // if all three props are set, render the component
  if (blok.title && blok.formId && blok.height) {
    return (
      <div {...storyblokEditable(blok)}>
        <PhnxJotformiframe title={blok.title} formId={blok.formId} height={blok.height + 'px'} />
      </div>
    )
  }
}

export default Jotformiframe
